/**
 * Корректирует позицию скролла для lux-страниц:
 * 1) Если в url есть hash, всегда прокручивает страницу к соответствующему DOM-элементу.
 * 2) Если был простой переход по ссылке, прокручивает страницу к верху.
 * 3) Если был переход по истории браузера (back/forward), ничего не делает,
 * полагаясь на поведение по-умолчанию самого браузера
 * */
const scrollCorrection = (locationHash: string, fromHistory: boolean): void => {
    if (locationHash) {
        const id = locationHash.replace('#', '');
        const escapedAttributeValue = id.replaceAll('"', '\\"');
        const anchor = document.getElementById(id) || document.querySelector(`a[name="${escapedAttributeValue}"]`);
        if (anchor) {
            window.scrollTo({
                top: anchor.offsetTop,
            });
        }
        return;
    }

    if (!fromHistory) {
        window.scrollTo(0, 0);
    }
};

export default scrollCorrection;
